'use client'

import { useAnimationsBase } from '@/hooks'
import { MEDIA } from '@spot'
import { uniqueId } from 'lodash'
import { memo, useImperativeHandle, useRef } from 'react'
import { BaseProps } from '../types'
import generateStyledJsx from './utils/styledJsx'

const Base = ({
  children,
  styled,
  as: Component = 'div',
  anim,
  animVars,
  animScrollVars,
  ref,
  ...props
}: BaseProps) => {
  //refs
  const comp = useRef<any>(null)
  const tl = useRef<GSAPTimeline | gsap.core.Tween | null>(null)

  useImperativeHandle(ref, () => comp.current as HTMLElement)

  //Hooks
  useAnimationsBase({
    ref: comp,
    anim: anim,
    tl,
    animVars: animVars,
    animScrollVars: animScrollVars
  })

  //Styles
  const { desktopStyles, tabletStyles, mobileStyles } =
    generateStyledJsx(styled)

  const id = uniqueId('jsx-')

  const styles =
    // prettier-ignore
    `[data-styled='${id}'] {${desktopStyles}}@media ${MEDIA.tablet} {[data-styled='${id}'] {${tabletStyles}}}@media ${MEDIA.mobile} {[data-styled='${id}'] {${mobileStyles}}}`
  if (styled) {
    return (
      <Component data-styled={id} ref={comp} {...props} data-anim={anim}>
        {children}
        <style jsx>{`
          ${styles}
        `}</style>
      </Component>
    )
  } else {
    return (
      <Component ref={comp} {...props} data-anim={anim}>
        {children}
      </Component>
    )
  }
}

Base.displayName = 'Base'

export default memo(Base)
